import React, { FunctionComponent, useEffect, useMemo, useState } from 'react'
import { Checkbox, Input, Modal, notification, Space, Typography } from 'antd'

import ChannelSelect from '../../../helpers/ChannelSelect/ChannelSelect'

import { getChannels, inviteUser } from '../../../../context/admin/utils'
import { Brand, Channel } from '../../../../context/types'

const { Paragraph } = Typography

interface InviteModalProps {
	visible: boolean
	onChange: (value: boolean) => void
	forceUpdate?: () => void
}

const InviteModal: FunctionComponent<InviteModalProps> = (props) => {
	const { visible, onChange, forceUpdate } = props

	const [email, setEmail] = useState('')
	const [isExpert, setIsExpert] = useState(false)
	const [isMultiple, setIsMultiple] = useState(false)

	const [brands, setBrands] = useState<Brand[]>([])
	const [channels, setChannels] = useState<Channel[]>([])

	const [channel, setChannel] = useState<Channel>()

	useEffect(() => {
		getChannels()
			.then((r) => {
				setBrands(r.brands)
				setChannels(r.channels)
			})
			.catch(() => {
				notification.error({ message: 'Server error' })
			})
	}, [])

	function handleInvite() {
		if (!email && !isMultiple) return

		inviteUser(email, isExpert, channel.id)
			.then(() => {
				notification.success({ message: 'Done' })
				// tslint:disable-next-line: no-unused-expression
				forceUpdate && forceUpdate()
			})
			.catch(handleError)
			.finally(() => onChange(false))
	}

	const handleError = (err: any) => {
		notification.error({ message: err.message || 'Error' })
	}

	function handleInviteCancel() {
		onChange(false)
	}

	const okButtonDisabled = useMemo(() => {
		return (!isMultiple && !email) || !channel?.id
	}, [email, channel?.id, isMultiple])

	return (
		<Modal
			title="Invite"
			visible={visible}
			onOk={handleInvite}
			onCancel={handleInviteCancel}
			okButtonProps={{ disabled: okButtonDisabled }}
		>
			<Space direction="vertical" size="large" style={{ width: '100%' }}>
				<section>
					<Paragraph>Email</Paragraph>
					<Input
						type="email"
						placeholder="Email"
						value={email}
						disabled={isMultiple}
						onChange={(e) => setEmail(e.target.value)}
					/>
				</section>

				<ChannelSelect channels={channels} brands={brands} onChange={setChannel} />

				<Space direction="horizontal" size="large">
					<Paragraph>
						<Checkbox checked={isExpert} onChange={(e) => setIsExpert(e.target.checked)}>
							Invite as expert
						</Checkbox>
						<Checkbox checked={isMultiple} onChange={(e) => setIsMultiple(e.target.checked)}>
							Multiple invites
						</Checkbox>
					</Paragraph>
				</Space>
			</Space>
		</Modal>
	)
}

export default InviteModal
